import { Routes } from '@angular/router';
import { AuthGuard } from '../core/guards/auth.guard';
import { FamilleGuard } from '../core/guards/famille.guard';

export const FAMILLE_ROUTES: Routes = [
  {
    path: 'famille/shared/medias',
    loadComponent: () =>
      import('../features/famille/shared/list/shared-media-list.component').then(m => m.SharedMediaListComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'famille/textes/list',
    loadComponent: () =>
      import('../features/famille/textes/list/textes-famille-list.component').then(
        m => m.TextesFamilleListComponent
      ),
    canActivate: [AuthGuard, FamilleGuard],
  },
  {
    path: 'famille/planning/list',
    loadComponent: () =>
      import('../features/famille/planning/list/planning-list.component').then(m => m.FamillePlanningListComponent),
    canActivate: [AuthGuard, FamilleGuard],
  },
  {
    path: 'famille/membres',
    loadComponent: () => import('../features/famille/membres/membres.component').then(m => m.FamilleMembresComponent),
    canActivate: [AuthGuard, FamilleGuard],
  },
  {
    path: 'famille/residents/:id/autorisés',
    loadComponent: () => import('../features/famille/autorisés/autorisés.component').then(m => m.FamilleAutorisésComponent),
    canActivate: [AuthGuard, FamilleGuard],
  },
  {
    path: 'famille/residents/:id/membres',
    loadComponent: () =>
      import('../features/famille/membres-resident/membres-resident.component').then(m => m.MembresResidentComponent),
    canActivate: [AuthGuard, FamilleGuard],
  },
  {
    path: 'famille/personnel/trombinoscope',
    loadComponent: () =>
      import('../features/personnel/famille/trombinoscope-famille.component').then(m => m.TrombinoscopeFamilleComponent),
    canActivate: [AuthGuard, FamilleGuard],
  },
  {
    path: 'famille/consentement',
    loadComponent: () =>
      import('../features/famille/consentement/consentement.component').then(m => m.ConsentementComponent),
    canActivate: [AuthGuard, FamilleGuard],
  },
  {
    path: 'famille/consentement/:token',
    loadComponent: () =>
      import('../features/famille/consentement/consentement.component').then(m => m.ConsentementComponent),
    canActivate: [AuthGuard, FamilleGuard],
  },
];
